
import useMouse from "@/compositions/mouse";

export default {
  setup(){
    const { x, y } = useMouse()

    return {
      x,
      y
    }
  }
}
